import React, { useState, useEffect } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './VerticalTimeline.css';
import timelineData from './TimelineData.json'; // Import the JSON file

const Timeline = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    // Simulate data fetching from the JSON file
    setData(timelineData);
  }, []);

  return (
    <div>
      <VerticalTimeline lineColor={"black"}>
        {data.map((item) => (
          <VerticalTimelineElement
            key={item.id}
            className={item.className}
            contentStyle={item.contentStyle}
            contentArrowStyle={{ borderRight: '10px solid #eee8e7' }}
            date={item.date}
            iconStyle={item.iconStyle}
          >
            <p>{item.description}</p>
            {item.image_url && <img src={item.image_url} alt="Timeline" style={{ maxWidth: '100%' }} />}
            {item.video_url && <video src={item.video_url} controls style={{ maxWidth: '100%' }} />}
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
};

export default Timeline;
